export enum PaymentProcessEnum {
  Stripe = 'stripe',
  Card = 'card',
  Generic = 'generic',
  RequestInvoice = 'request_invoice',
}
